// ============================================
// モジュール読み込み
// ============================================
import initCommonScripts from "./libs/common";
import { viewport } from "./libs/viewport";
initCommonScripts();
window.addEventListener("DOMContentLoaded", () => {
    viewport();
});
